import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import get from 'lodash/get';

import Input from '../../../components/UI/CustomInputField';
import WidgetPropTypes from '../types';
import WidgetPagePropTypes from '../../WidgetPage/types';
import { isValidEmail } from '../../../helpers';

export const WIDGET_NAME = 'set_user_email';
export const DEBOUNCE = 300;

class Email extends Component {
  state = {
    email: '',
    error: false,
    message: '',
    continue: false,
    displayInvalidEmailMessage: false
  };

  componentDidMount() {
    this.props.analytics.trackEvent('Registration Enter Email Viewed');
    const prefilledEmail =
      this.props.user.urlEmail ||
      get(this.props, 'app.prefilledAnswers.setUserEmail');
    if (prefilledEmail) {
      this.setState({
        email: prefilledEmail
      });
      this.props.shouldEnable(this.props.widget, true);
      this.props.changeAnswerValue(this.props.widget, prefilledEmail);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { changeAnswerValue, widget, shouldEnable } = this.props;

    if (this.state.email !== prevState.email) {
      changeAnswerValue(widget, this.state.email);

      if (this.state.email) {
        shouldEnable(widget, true);
      }
    }
  }

  // function that does nothing
  noop = () => {
    // This is intentional
  };

  isValid = debounce(() => {
    this.props.checkValidEmail(this.state.email);
  }, DEBOUNCE);

  validateEmailOnBlur = () => {
    // do not show error helper text if user taps email field, enters nothing, then taps elsewhere
    if (!this.state.email.length) return;

    const isValid = isValidEmail(this.state.email);
    if (isValid) {
      this.setState({ displayInvalidEmailMessage: false });
    } else {
      this.setState({ displayInvalidEmailMessage: true });
    }
  };

  onChange = value => {
    const trimmedEmail = value.trim();
    this.setState({ email: trimmedEmail }, () => {
      if (this.state.email.indexOf('@') > 0) this.isValid();
    });
  };

  replaceWithCorrection = () => {
    this.setState({ email: this.props.user.emailCorrection });
  };

  errorChecking = async () => {
    if (!isValidEmail(this.state.email)) {
      this.setState({ error: true });
      this.props.createError({
        message: 'Please enter a valid email',
        registrationStep: WIDGET_NAME
      });

      throw new Error();
    }
    this.setState({ error: false });
    this.props.clearError();
    return false;
  };

  render() {
    return (
      <div style={{ textAlign: 'left' }}>
        <Input
          id="emailId"
          placeholder="Email address"
          error={this.state.error}
          value={this.state.email}
          autoComplete="off"
          autoCorrect="off"
          inputMode="text"
          onInput={value => this.onChange(value)}
          onClick={this.props.onClick}
          onBlur={
            this.props.toggles.emailBlurEnabled
              ? this.validateEmailOnBlur
              : this.noop
          }
          data-e2e="email"
          format={
            this.state.displayInvalidEmailMessage
              ? 'Please enter a valid email address'
              : ''
          }
        />
        {this.props.user.emailCorrection &&
          this.props.user.emailCorrection !== this.state.email && (
            <a
              onClick={this.replaceWithCorrection}
              className="fs-mask"
              data-e2e="email-update"
            >{`Did you mean ${this.props.user.emailCorrection}?`}</a>
          )}
      </div>
    );
  }
}

Email.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired,
  app: WidgetPagePropTypes.app,
  checkValidEmail: WidgetPagePropTypes.checkValidEmail
};

export default Email;
